import {
    createPageMetricsForResponse,
    PageType,
} from '@jet-app/music-classical/metrics/page';
import { ObjectGraph } from '@jet/environment/dependencies';
import type {
    BrowseDetailPage,
    PageKind,
} from '@jet-app/music-classical/models';
import type {
    ClassicalAPIResponse,
    ClassicalGrid,
    ClassicalListItem,
    ClassicalAPIResponseHeader,
    ClassicalSection,
} from '@jet-app/music-classical/api/types';
import { transformSections } from '@jet-app/music-classical/utilities/transforms/sections';
import { getBaseSeoData } from '@jet-app/music-classical/utilities/seo/BaseSeoData';
import { transformToGridSection } from '@jet-app/music-classical/utilities/transforms/grid';
import { makePageHeader } from '../../common/page-header';
import { addingBrowseDetailSeoData } from '@jet-app/music-classical/utilities/seo/BrowseDetail';

export function renderBrowseDetailPage(
    canonicalURL: string,
    apiResponse: ClassicalAPIResponse,
    entityType: string,
    objectGraph: ObjectGraph,
): BrowseDetailPage {
    const responseBody = apiResponse?.body;
    const responseHeader = (responseBody?.header ||
        {}) as unknown as ClassicalAPIResponseHeader;
    let sections: any[] = [];

    if (!responseBody?.sections && 'firstPage' in responseBody) {
        // Temporary fix for List Screen till Classical API Server makes change to convert the list screen to component screen
        responseBody.type = 'componentScreen';
        sections = transformListScreenToGridView(
            responseBody?.firstPage?.items as unknown as ClassicalListItem[],
            objectGraph,
        );
    } else {
        sections =
            transformSections(
                apiResponse?.body?.sections as unknown as ClassicalSection[],
                objectGraph,
            ) || [];
    }

    const page: BrowseDetailPage = {
        pageKind: responseBody?.type as unknown as PageKind,
        kind: 'browseDetailPage',
        header: makePageHeader(responseHeader),
        sections,
        canonicalURL,
        pageMetrics: createPageMetricsForResponse(
            apiResponse,
            PageType.browsePage,
        ),
    };

    return addingBrowseDetailSeoData(
        canonicalURL,
        page,
        entityType,
        objectGraph,
    );
}

export function transformListScreenToGridView(
    items: ClassicalListItem[],
    objectGraph: ObjectGraph,
): Array<any> {
    return [
        transformToGridSection(
            {
                items: items.map((item: ClassicalListItem) => ({
                    title: item.title,
                    subtitle: item.subtitle,
                    image: item.image,
                    action: item.action,
                    type: item.type,
                    id: item.id,
                })),
            } as unknown as ClassicalGrid,
            getItemKindFromType(items?.[0]?.type),
            null,
            objectGraph,
        ),
    ];
}

export function getItemKindFromType(type: string) {
    return type === 'playlist' ? 'squareLockup' : 'rectangularLinkLockup';
}
